import { render, staticRenderFns } from "./HomeUserInfo.vue?vue&type=template&id=098b8d40&scoped=true&"
import script from "./HomeUserInfo.vue?vue&type=script&lang=js&"
export * from "./HomeUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./HomeUserInfo.vue?vue&type=style&index=0&id=098b8d40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098b8d40",
  null
  
)

export default component.exports